<template>
  <div>
    <div class="ma-page-head">
      <div>
        <h1 class="ma-page-title">
          Bonjour, {{ firstName }} 👋
        </h1>
        <p class="ma-page-sub">
          Voici l'état actuel de la plateforme Minds' Academy.
        </p>
      </div>
    </div>

    <div
      v-if="loading"
      class="ma-loading"
    >
      Chargement…
    </div>

    <template v-else>
      <div class="ma-stats">
        <div class="ma-stat">
          <div class="ma-stat-ico teal">
            <feather-icon
              icon="UsersIcon"
              size="22"
            />
          </div>
          <div class="ma-stat-value">
            {{ stats.students }}
          </div>
          <div class="ma-stat-label">
            Étudiants
          </div>
        </div>
        <div class="ma-stat">
          <div class="ma-stat-ico coral">
            <feather-icon
              icon="UserCheckIcon"
              size="22"
            />
          </div>
          <div class="ma-stat-value">
            {{ stats.tutors }}
          </div>
          <div class="ma-stat-label">
            Tuteurs
          </div>
        </div>
        <div class="ma-stat">
          <div class="ma-stat-ico indigo">
            <feather-icon
              icon="LayersIcon"
              size="22"
            />
          </div>
          <div class="ma-stat-value">
            {{ stats.groups }}
          </div>
          <div class="ma-stat-label">
            Groupes
          </div>
        </div>
      </div>

      <div
        class="ma-card"
        style="margin-top: 22px; padding: 24px;"
      >
        <h3 style="font-weight:800;margin:0 0 4px;">
          Groupes par niveau
        </h3>
        <p class="ma-page-sub" style="margin-bottom:18px;">
          Répartition des groupes selon le niveau scolaire.
        </p>
        <div
          v-if="stats.byLevel && stats.byLevel.length"
          class="ma-level-bars"
        >
          <div
            v-for="l in stats.byLevel"
            :key="l.level"
            class="ma-level-row"
          >
            <span class="ma-level-tag">{{ l.level }}</span>
            <div class="ma-level-track">
              <div
                class="ma-level-fill"
                :style="{ width: barWidth(l.count) }"
              />
            </div>
            <span class="ma-level-count">{{ l.count }}</span>
          </div>
        </div>
        <div
          v-else
          class="ma-empty"
          style="padding:30px;"
        >
          Aucun groupe pour le moment.
        </div>
      </div>

      <div
        class="ma-card"
        style="margin-top: 22px; padding: 24px; display:flex; gap:14px; flex-wrap:wrap;"
      >
        <router-link
          class="ma-btn ma-btn-primary"
          :to="{ name: 'minds-admin-students' }"
        >
          <feather-icon
            icon="PlusIcon"
            size="16"
          /> Ajouter des étudiants
        </router-link>
        <router-link
          class="ma-btn ma-btn-ghost"
          :to="{ name: 'minds-admin-tutors' }"
        >
          <feather-icon
            icon="UserPlusIcon"
            size="16"
          /> Ajouter un tuteur
        </router-link>
        <router-link
          class="ma-btn ma-btn-ghost"
          :to="{ name: 'minds-admin-groups' }"
        >
          <feather-icon
            icon="LayersIcon"
            size="16"
          /> Créer un groupe
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import axios from '@axios'
import { getUserData } from '@/auth/utils'

export default {
  name: 'MindsAdminDashboard',
  data() {
    return {
      loading: true,
      stats: {
        students: 0, tutors: 0, groups: 0, byLevel: [],
      },
    }
  },
  computed: {
    firstName() {
      const u = getUserData() || {}
      return (u.fullName || 'Admin').split(/\s+/)[0]
    },
    maxLevel() {
      return Math.max(1, ...(this.stats.byLevel || []).map(l => l.count))
    },
  },
  mounted() { this.fetch() },
  methods: {
    async fetch() {
      try {
        const res = await axios.get('/ma/admin/stats')
        this.stats = res.data
      } catch (e) {
        // silencieux
      } finally {
        this.loading = false
      }
    },
    barWidth(count) {
      return `${Math.max(8, Math.round((count / this.maxLevel) * 100))}%`
    },
  },
}
</script>

<style src="./minds.css"></style>
<style scoped>
.ma-level-bars { display: flex; flex-direction: column; gap: 14px; }
.ma-level-row { display: flex; align-items: center; gap: 14px; }
.ma-level-tag { width: 40px; font-weight: 800; color: #0E9384; }
.ma-level-track { flex: 1; height: 12px; background: #EEF2F6; border-radius: 20px; overflow: hidden; }
.ma-level-fill { height: 100%; border-radius: 20px; background: linear-gradient(90deg, #14B8A6, #2DD4BF); }
.ma-level-count { width: 30px; text-align: right; font-weight: 700; color: #475569; }
</style>
